import * as React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';

export default function AlertDialog({discription, open, handleSetOpen, logoutHandler}) {

  const handleClose = () => {
    handleSetOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle >
          {"خروج از حساب کاربری"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {discription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button sx={{
          borderRadius:1, 
          backgroundColor:'#05C6C5', 
          "&:hover": {
                backgroundColor: "#05C6C5",
                boxShadow: "none",
              },
          "&:active": {
                boxShadow: "none",
                backgroundColor: "#05C6C5",
              }}} 
          onClick={logoutHandler} autoFocus>
            <Typography sx={{color:'#fff'}} fontSize={14} fontWeight={500}>{'تایید'}</Typography>
          </Button>
          <Button onClick={handleClose}>
            <Typography sx={{color:'#05C6C5'}} fontSize={14} fontWeight={500}>{'انصراف'}</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}